import { useDrfqTakerOrderbook } from '@paradigm/features/src/unified-rfqs/ui/drfq/drfq-taker-orderbook-context';
import { ArrowDown } from '../../rfq-common/TableRow';
import { ONE_CLICK_ACTION_WIDTH } from '../components/RfqRowBase';
import OrderbookDrfqRow from './OrderbookDrfqRow';
import { TakerRepriceRowAction } from './RepriceRowAction';

export default function DrfqTakerRowAction() {
  const view = useDrfqTakerOrderbook();

  let content = null;

  switch (view.state) {
    case 'LOADING_ORDERS':
      content = <OrderbookDrfqRow />;
      break;
    case 'MATCHED_AUCTION':
    case 'UNMATCHED_AUCTION':
      content = <TakerRepriceRowAction />;
      break;
    case 'OPEN_AUCTION':
      content = <OrderbookDrfqRow />;
      break;
    // no default
  }

  return (
    <>
      {content}
      <ArrowDown actionWidth={ONE_CLICK_ACTION_WIDTH} />
    </>
  );
}
